export interface City {
  name: string;
  slug: string;
  tier: string;
}

export const cities: City[] = [
  { name: 'London', slug: 'london', tier: 'Tier 1 (London)' },
  { name: 'Birmingham', slug: 'birmingham', tier: 'Tier 2 (Major Cities)' },
  { name: 'Manchester', slug: 'manchester', tier: 'Tier 2 (Major Cities)' },
  { name: 'Leeds', slug: 'leeds', tier: 'Tier 2 (Major Cities)' },
  { name: 'Liverpool', slug: 'liverpool', tier: 'Tier 2 (Major Cities)' },
  { name: 'Glasgow', slug: 'glasgow', tier: 'Tier 2 (Major Cities)' },
  { name: 'Edinburgh', slug: 'edinburgh', tier: 'Tier 2 (Major Cities)' },
  { name: 'Cardiff', slug: 'cardiff', tier: 'Tier 3 (Wales)' },
  { name: 'Newport', slug: 'newport', tier: 'Tier 3 (Wales)' },
  { name: 'Swansea', slug: 'swansea', tier: 'Tier 3 (Wales)' },
  { name: 'Bristol', slug: 'bristol', tier: 'Tier 2 (Major Cities)' },
  { name: 'Newcastle', slug: 'newcastle', tier: 'Tier 2 (Major Cities)' }
];

// Export as CITIES for backward compatibility
export const CITIES = cities;
